.form {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  max-width: 50rem;
  min-width: 50rem;

  & > div:last-child {
    margin-top: 1.6rem;
  }

  & > div:not(:last-child) {
    span {
      bottom: -1.8rem;
      color: var(--color-error);
      font-size: 1rem;
    }
  }
}
